<template>
  <div class="ql-main-container">
    <div>
      <Editor
        v-model="content"
        :init="tinymceConfig"
        :disabled="disabled"
        api-key="m3igkkp09gzntvtyyx6hiz8c1vzrpu88my9yl2fjhn7fd44l"
        style="min-height:300px"
        @input="onInput"
      ></Editor>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  name: 'text-area-style',
  components: { Editor },
  props: ['text', 'disabled'],
  data() {
    return {
      content: this.text || '',
      tinymceConfig: {
        height: 400,
        menubar: true,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
          'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      },
      apiKey: process.env.TINYMCE_API_KEY
    }
  },
  watch: {
    text(newVal) {
      if (newVal !== this.content) {
        this.content = newVal || '';
      }
    }
  },
  methods: {
    saveFromEditor() {
      this.$emit('update:text', this.content);
      this.$emit('change', this.content);
    },
    onInput(newContent) {
      if (newContent !== this.text) {
        this.$emit('update:text', newContent);
        this.$emit('change', newContent);
      }
    }
  }
}
</script>
